import { render, staticRenderFns } from "./MessagesHistory.vue?vue&type=template&id=e4bbd4be&scoped=true&"
import script from "./MessagesHistory.vue?vue&type=script&lang=ts&"
export * from "./MessagesHistory.vue?vue&type=script&lang=ts&"
import style0 from "./MessagesHistory.vue?vue&type=style&index=0&id=e4bbd4be&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e4bbd4be",
  null
  
)

export default component.exports